<template>
  <div class="target-text">
    <div class="toc" v-if="!index">
      <i class="bi bi-list-task"></i>
      <ul>
        <li v-for="toc in text.toc">{{ toc }}</li>
      </ul>
    </div>
    <div v-for="(t, ti) in elems" :key="'a-' + ti">
      <div class="text-item" v-if="t.type !== 'h2'">

        <table v-if="t.type === 'table'">
          <tr v-for="row in t.rows">
            <td v-for="td in row">{{ td }}</td>
          </tr>
        </table>

        <figure class="content-figure" v-if="t.type === 'image'">
          <i class="bi bi-file-earmark-image-fill"></i>
          <figcaption>
            <span>Title</span> {{ t.title }}<br>
            <span>Alt</span> {{ t.alt }}<br>
            <span>Caption</span> {{ t.caption }}
          </figcaption>
        </figure>

        <div v-if="t.type === 'rows'" class="list">
          <ul>
            <li v-for="li in t.text">{{ li }}</li>
          </ul>
        </div>

        <p v-if="t.type === 'p'">
          {{ t.text }}
          <span class="chars">{{ t.len }} симв.</span>
        </p>

      </div>
    </div>
   <div class="links" v-if="block?.links?.length">
     <div class="title"><i class="bi bi-link-45deg"></i> Ссылки</div>
      <div class="link" v-for="link in block.links" :key="link[0]">
        <span class="anchor" title="Анкор">{{ link[1] }}</span>
        <span class="url" title="Ссылка">{{ link[0] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TargetTextOne',
  props: {
    text: {type: Object, required: true},
    block: {type: Object, required: true},
    elems: {type: Array, required: true},
    index: {type: Number, required: true}
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.target-text {
    display: flex;
  flex-direction: column;
  min-height: 100%;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* ---------- Общий контейнер блока ---------- */
.text-item {
  position: relative;
  padding: 6px 0 6px 14px;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #343a40;


  .chars {
    display: inline-block;
    margin-left: 6px;
    font-size: 0.7rem;
    color: #adb5bd;
    font-variant-numeric: tabular-nums;
  }
}

/* ---------- Оглавление (TOC) ---------- */
.toc {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.8rem;
  color: #495057;
  display: flex;

  i.bi {
    display: inline-block;
    margin-right: 6px;
    color: #6c757d;
    font-size: 0.9rem;
    vertical-align: middle;
  }

  ul {
    display: inline-block;
    vertical-align: middle;
  }

  li {
    position: relative;
    padding: 2px 0 2px 12px;
    line-height: 1.4;
    color: #495057;
    cursor: default;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.7em;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #ced4da;
    }

    &:hover {
      color: #212529;
    }
  }
}

.links {
    margin-top: auto;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  gap: 4px;

  padding: 8px 12px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  border-radius: 0 0 6px 6px;

  font-size: 0.75rem;
  line-height: 1.4;

  max-height: 120px;
  overflow-y: auto;

  .link {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 2px 0;
    min-width: 0;

    .anchor {
      flex: 0 0 auto;
      max-width: 40%;
      color: #495057;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .url {
      flex: 1 1 auto;
      min-width: 0;
      color: #868e96;
      font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
      font-size: 0.7rem;
      overflow: hidden;
      text-overflow: ellipsis;
      direction: rtl;      /* чтобы обрезалось начало длинного URL */
      text-align: left;
    }

    &:hover {
      .anchor { color: #212529; }
      .url    { color: #495057; }
    }
  }
}

/* ---------- Таблица ---------- */
table {
  width: 100%;
  margin: 6px 0;
  border-collapse: collapse;
  font-size: 0.78rem;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;

  tr {
    &:nth-child(even) {
      background: #f8f9fa;
    }

    &:hover {
      background: #f1f3f5;
    }
  }

  td {
    padding: 6px 10px;
    border: 1px solid #e9ecef;
    color: #343a40;
    vertical-align: top;
    line-height: 1.4;
    word-break: break-word;
  }

  /* Первая строка как «заголовок» */
  tr:first-child td {
    background: #f1f3f5;
    font-weight: 600;
    color: #212529;
  }
}

/* ---------- Изображение / figure ---------- */
.content-figure {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 6px 0;
  padding: 10px 12px;
  background: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 6px;

  i.bi {
    flex: 0 0 auto;
    font-size: 1.4rem;
    line-height: 1;
    color: #868e96;
    margin-top: 2px;
  }

  figcaption {
    flex: 1 1 auto;
    font-size: 0.78rem;
    line-height: 1.5;
    color: #495057;
    word-break: break-word;

    span {
      display: inline-block;
      min-width: 56px;
      margin-right: 4px;
      color: #868e96;
      font-weight: 600;
      font-size: 0.7rem;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
  }
}

/* ---------- Список (rows) ---------- */
.list {
  margin: 4px 0;

  ul {
    padding-left: 0;
  }

  li {
    position: relative;
    padding: 3px 0 3px 14px;
    font-size: 0.82rem;
    line-height: 1.5;
    color: #343a40;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.75em;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #adb5bd;
    }

    &:hover::before {
      background: #6c757d;
    }
  }
}

/* ---------- Абзац ---------- */
p {
  margin: 4px 0;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #343a40;
  word-break: break-word;

  .chars {
    display: inline-block;
    margin-left: 6px;
    font-size: 0.7rem;
    color: #adb5bd;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
}

</style>